<div class="flex justify-between gap-4 pb-4">
  <div class="flex flex-col gap-4 flex-1 min-w-0">
    <div class="flex items-center gap-4">
      <div class="bg-white rounded-lg">
        <p-button [label]="'Back'"
                  [severity]="'secondary'"
                  [outlined]="true"
                  [icon]="'fa fa-chevron-left'"
                  (onClick)="goBack()"
        ></p-button>
      </div>

      <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">
        {{ 'Travel Allowance Approval for ' + taSubmission()?.taNumber }}
      </div>

      <div class="flex gap-1 items-center">
        @if (travellersLength() > 1) {
          <i class="fa-solid fa-users"></i>
          <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name + ' (+' + (travellersLength() - 1) + ')'}}</div>
        } @else {
          <i class="fa-solid fa-user"></i>
          <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name}}</div>
        }
      </div>

      <div class="flex-1"></div>
    </div>

    <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">{{'Travel Date: ' + ((taSubmission()?.startDate | date: 'dd/MM/yy') ?? '-') }}</div>


    <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">
      {{message()}}
    </div>

    <!-- Status-specific content, e.g. the approvals table. -->
    <ng-content></ng-content>
  </div>

  <!-- A Cancelled TA only gets the acquittal set when a processed prepayment is being recovered
       (as on manage-ta-cancel-finalise); an immediate cancel keeps its values, so nothing is due. -->
  @if (taSubmissionDatasource.isFlightOnly()) {
    <!-- Flight-only TAs carry no allowance value. -->
  } @else if (taSubmission()?.status === 'AcquittalComplete' || taSubmission()?.status === 'AcquittalApproved' || taSubmission()?.status === 'Finalised' || (taSubmission()?.status === 'Cancelled' && overpaymentMade() > 0)) {
    <div class="flex flex-col gap-2 items-end">
      <ta-cost-bubble title="Approved TA Value" [value]="originalTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Acquitted TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Change in TA Value" [value]="acquittedValueChange()" [severity]="acquittedValueChange() === 0 ? 'text' : 'outlined'" [signed]="true"></ta-cost-bubble>
      <ta-cost-bubble title="Finalisation Payment Due" [value]="finalisationPaymentDue()" severity="primary"></ta-cost-bubble>
      <div class="w-full h-[1px] bg-surface-200"></div>
      @if (isPrePaid()) {
        <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
        @if (overpaymentMade() > 0) {
          <ta-cost-bubble title="Overpayment Made" titleIcon="fa-regular fa-piggy-bank text-[#DC2626]" [value]="overpaymentMade()" severity="danger"></ta-cost-bubble>
        }
      }
      <ta-cost-bubble title="Day Trip Component" [value]="dayTripComponent()" severity="purple"></ta-cost-bubble>
    </div>
  } @else {
    <div class="flex flex-col gap-2 items-end">
      <ta-cost-bubble title="Total TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
    </div>
  }
</div>
